export interface IAppStateTransitionController {
  schedule(callback: () => void, delayMs?: number): void;
  cancel(): void;
}

export const createAppStateTransitionController = (): IAppStateTransitionController => {
  let pendingTimer: ReturnType<typeof setTimeout> | undefined;

  return {
    schedule(callback: () => void, delayMs = 150): void {
      if (pendingTimer) {
        clearTimeout(pendingTimer);
      }

      pendingTimer = setTimeout(() => {
        pendingTimer = undefined;
        callback();
      }, delayMs);
    },
    cancel(): void {
      if (pendingTimer) {
        clearTimeout(pendingTimer);
        pendingTimer = undefined;
      }
    },
  };
};
